import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

export class MarketingAnalyticsUserInstallEventType extends MarketingAnalyticsEventType {
    canHandle(event: any): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_USER_INSTALL;
    }

    getBody(event: any): MarketingAnalyticsEvent {
        const baseEvent = this.baseEvent(event);
        return baseEvent;
    }
}
